export enum DayInAdvanceType {
    AT_BOOKING = "at_booking",
    AT_ARRIVAL = "at_arrival",
    CUSTUM = "custom",
}
